import Snowplow from './Snowplow.js';
import Dealer from './contexts/Dealer.js';
import Vehicle from './contexts/Vehicle.js';
import Gateway from './Gateway.js';
import StructuredEvent from './events/Structured.js';
import OnlineSales2 from './contexts/OnlineSales2.js';
import OvsEntryPoint from './storage/OvsEntryPoint.js';
import OvsPreviousStep from './storage/OvsPreviousStep.js';
import Contexts from './Contexts.js';
import ConfigManager from './snowplow/ConfigManager.js';

export default class BaseTagger {
  constructor(defaultConfig, trackerConfig) {
    const configManager = new ConfigManager(defaultConfig, trackerConfig);
    this.snowplow = new Snowplow(configManager.config);
    this.contexts = new Contexts();
  }

  /**
   * Adding Dealer Context.
   * An optional method if the project is working without Auto v10.
   * All params are optional. If there is no able to get it from the project just put null value.
   * @param {string|null} groupHash - Group hash
   * @param {string|null} franchiseHash - Franchise hash
   * @param {string|null} locationHash - Location hash
   * @param {string|null} brandName - manufacturer, e.g. Audi, BMW
   * @param {string|null} gsh - Group software hash
   * @param {string|null} host - Site host
   */
  addDealerContext(groupHash, franchiseHash, locationHash, brandName, gsh, host) {
    this.snowplow.globalContexts.add(new Dealer(groupHash, franchiseHash, locationHash, brandName, gsh, host));
  }

  /**
   * Adding Vehicle Context.
   * An optional method if the project is working without Auto v10.
   * @param {integer} id - Vehicle Id
   * @param {string} make - Manufacturer
   * @param {string} model - Vehicle model
   * @param {string|null} variant - Vehicle Variant
   * @param {number|null} price - Price
   * @param {string|null} registrationDate - Registration Date
   * @param {string|null} efficiencyUnit - Efficiency Unit
   * @param {string|null} guid - Vehicle Guid
   */
  addVehicleContext(id, make, model, variant, price, registrationDate, efficiencyUnit, guid) {
    try {
      const context = new Vehicle();
      context.setId(id)
        .setManufacturer(make)
        .setModel(model)
        .setVariant(variant)
        .setPrice(price)
        .setRegistrationDate(registrationDate)
        .setEfficiencyUnit(efficiencyUnit)
        .setGuid(guid);
      this.snowplow.globalContexts.add(context);
    } catch (e) {
      Gateway.window.console.warn(e.message);
    }
  }

  /**
   * Adding Online Sales Context
   * @param {string} step - current OVS step
   */
  addOnlineSalesContext(step) {
    const entryPoint = OvsEntryPoint.get();
    const previousStep = OvsPreviousStep.get();
    OvsPreviousStep.set(step);
    const context = new OnlineSales2(step, previousStep, entryPoint);
    this.snowplow.globalContexts.update(context);
  }

  /**
   * Tagging a structured event.
   * {@link https://docs.snowplowanalytics.com/docs/collecting-data/collecting-from-own-applications/javascript-tracker/tracking-specific-events/#Tracking_custom_structured_events|Documentation}
   * @param {string} category
   * @param {string} action
   * @param {string|null} label
   * @param {string|null} property
   * @param {string|null} value
   */
  trackStructuredEvent(category, action, label, property, value) {
    const structuredEvent = new StructuredEvent(this.snowplow);
    structuredEvent.setContexts(this.contexts);
    structuredEvent.setData(category, action, label, property, value);
    structuredEvent.send();
  }
}
